import UserModel from 'common/models/user';
import AuthService from 'services/auth';
import {createState} from './createState';

interface UserStore {
	[key: string]: unknown;
	user: UserModel | null;
	// session/info failed; App shows an error with a retry instead of a blank page
	userLoadFailed: boolean;
	login: () => Promise<void>;
	logout: () => Promise<void>;
	getUser: () => Promise<void>;
	authenticate: (code: string, state: string) => Promise<void>;
	setRequiredRoles: (unauthorized: string[]) => void;
	requiredRoles: string[] | null;
}

const useUserStore = createState<UserStore>('User store', (set) => ({
	user: null,
	userLoadFailed: false,
	requiredRoles: null,
	login: () => AuthService.login(),
	logout: () => AuthService.logout(),
	getUser: async () => {
	  const user = await AuthService.getUser();
	  set({user: user ? new UserModel(user) : null, userLoadFailed: !user}, false, 'USER/SET');
	},
	setRequiredRoles: (unauthorized) =>
	  set({requiredRoles: unauthorized}, false, 'USER/SET_REQUIRED_ROLES'),
	authenticate: async (code: string, state: string) =>
	  await AuthService.authenticate(code, state),
}));

export const useUser = () => useUserStore((state) => state.user);

export default useUserStore;
